import defaultFetch from 'isomorphic-unfetch';
import type { GroupBookingAPIResponse } from '@/scopes/account/group-responsible/infrastructure/types';
import { groupBookingMapper } from './groupResponsibleMappers';
import type { GroupBookingData } from '@/scopes/account/group-responsible/domain/types';

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string;
  };
  fetch: typeof defaultFetch;
}

function createGroupResponsibleAPIClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
  } = dependencies as Dependencies;

  async function getGroupBookingData(masterBookingNumber: string): Promise<GroupBookingData> {
    const response = await fetch(
      `${env.NEXT_PUBLIC_API_BASE_URL}/GroupBookingsApi/GetGroupBooking/?masterBookingNumber=${masterBookingNumber}`
    );
    const data: GroupBookingAPIResponse = await response.json();
    return groupBookingMapper(data);
  }

  return {
    getGroupBookingData,
  };
}

export default createGroupResponsibleAPIClient();
